import { useState, useEffect } from "react";
import ImageMagnifier from "../ImageMagnifier";
import CarouselVideo from "./CarouselVideo";
import PcSwiper from "./PcSwiper";
import MobileSwiper from "./MobileSwiper";
import { Skeleton } from "antd";

const ProductImagesSkeleton = () => {
  return (
    <>
      {/* PC Skeleton */}
      <div className="hidden lg:block">
        <div className="relative h-[535px] w-[470px]">
          <Skeleton.Image active style={{ width: "470px", height: "535px" }} />
        </div>
        <div className="mt-4 flex gap-2">
          {[...Array(1)].map((_, i) => (
            <Skeleton.Image
              key={i}
              active
              style={{ width: "100px", height: "100px" }}
            />
          ))}
        </div>
      </div>

      {/* Mobile Skeleton */}
      <div className="block lg:hidden">
        <Skeleton.Image active style={{ width: "100%", height: "300px" }} />
      </div>
    </>
  );
};

/**
 * product detail page, product images component
 * @param imagesData images data
 * @param videoUrl video url
 */
const ProductImages = ({
  imagesData,
  videoUrl,
  loading = false, // 默认值为 false
}: {
  imagesData: string[];
  videoUrl?: string;
  loading?: boolean;
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [url, setUrl] = useState<string>("");
  const [images, setImages] = useState<string[]>([]);
  const [video, setVideo] = useState<string | undefined>(undefined);

  // swiper slide mouse enter event
  const handleMouseEnter = (url: string, index: number) => {
    setUrl(url);
    setActiveIndex(index);
  };

  useEffect(() => {
    if (!loading) {
      setImages(imagesData);
      setVideo(videoUrl);
      setUrl(imagesData[0]);
      setActiveIndex(0);
    }
  }, [imagesData, videoUrl, loading]);

  // 显示骨架屏
  if (loading || !imagesData?.length) {
    return <ProductImagesSkeleton />;
  }
  return (
    <>
      {/* pc */}
      <div className="hidden lg:block">
        <div className="relative h-[535px] w-[470px]">
          <ImageMagnifier minImg={url} maxImg={url}></ImageMagnifier>
          {video && <CarouselVideo video={video} />}
        </div>

        <PcSwiper
          images={images}
          activeIndex={activeIndex}
          handleMouseEnter={handleMouseEnter}
        />
      </div>

      {/* mobile */}
      <div className="relative block lg:hidden">
        {video && <CarouselVideo video={video} />}
        <MobileSwiper images={images} activeIndex={activeIndex} />
      </div>
    </>
  );
};

export default ProductImages;